import { useTypedDispatch } from "@/redux/helpers/hooks";
import { ICartItemProps } from "../../cartInterface";
import { useEffect, useState } from "react";
import useDebouncedValue from "@/lib/helpers/hooks/useDebouncedValue";
import { updateCartItem } from "@/redux/slices/user/thunks/updateCartItem";
import { getCart } from "@/redux/slices/user/thunks/getCart";
import { Input, Select } from "@/template/components";

const DomainContactType = ({ item, reviewOrder }: Partial<ICartItemProps>) => {
  const dispatch = useTypedDispatch();
  const standardInputDetails = {
    placeholder: "Registered Company Number",
  };

  const itemCompanyNumber = item.extra_details.uk_company_number;
  const itemCompanyType = item.extra_details.uk_company_type;

  const [companyNumber, setCompanyNumber] = useState(itemCompanyNumber);
  const [companyType, setCompanyType] = useState(itemCompanyType);
  const [mounted, setMounted] = useState(false);
  const debouncedCompanyNumber = useDebouncedValue(companyNumber, 500);

  const options = [
    {
      key: "LTD",
      label: "UK Registered Limited Company",
      inputDetails: standardInputDetails,
    },
    {
      key: "PLC",
      label: "UK Public Limited Company",
      inputDetails: standardInputDetails,
    },
    {
      key: "PTNR",
      label: "UK Partnership",
    },
    {
      key: "STRA",
      label: "UK Sole Trader",
    },
    {
      key: "LLP",
      label: "UK Limited Liability Partnership",
      inputDetails: standardInputDetails,
    },
    {
      key: "IP",
      label: "UK Industrial/Provident Registered Company",
      inputDetails: standardInputDetails,
    },
    {
      key: "IND",
      label: "UK Individual (representing self)",
    },
    {
      key: "SCH",
      label: "UK School",
      inputDetails: {
        placeholder: "Registered School Number",
      },
    },
    {
      key: "RCHAR",
      label: "UK Registered Charity",
      inputDetails: {
        placeholder: "Registered Charity Number",
      },
    },
    {
      key: "GOV",
      label: "UK Government Body",
    },
    {
      key: "CRC",
      label: "UK Corporation by Royal Charter",
    },
    {
      key: "STAT",
      label: "UK Statutory Body",
    },
    {
      key: "OTHER",
      label:
        "UK Entity that does not fit into any of the above (e.g. clubs, associations, many universities)",
    },
    {
      key: "FIND",
      label: "Non-UK Individual (representing self)",
    },
    {
      key: "FCORP",
      label: "Non-UK Corporation",
    },
    {
      key: "FOTHER",
      label:
        "Non-UK Entity that does not fit into any of the above (e.g. charities, schools, clubs, associations)",
    },
  ];

  const selectedOptionKey = item.extra_details.uk_company_type;
  const selectedOptionDetails = options.find(
    (option) => option.key === selectedOptionKey
  );

  useEffect(() => {
    if (mounted) {
      dispatch(
        updateCartItem({
          id: item.id,
          slug: `/svc/cart/domain-details/${item.id}`,
          data: {
            extra_details: {
              uk_company_type: companyType,
              uk_company_number: debouncedCompanyNumber,
            },
          },
        })
      ).then(() => dispatch(getCart()));
    } else {
      setMounted(true);
    }
  }, [debouncedCompanyNumber, companyType]);

  return (
    <>
      <Select
        placeholder="Select An Option"
        label="Contact Type"
        required
        fullWidth
        loading={item.loading}
        disabled={item.loading || reviewOrder}
        selected={selectedOptionKey}
        options={options}
        onChange={setCompanyType}
        popupProps={{
          width: 200,
          placement: "bottom-end",
        }}
      />
      {selectedOptionDetails?.inputDetails && (
        <Input
          label="Register Company Number"
          required
          fullWidth
          value={companyNumber}
          loading={item.loading}
          disabled={item.loading || reviewOrder}
          onChange={setCompanyNumber}
          {...selectedOptionDetails.inputDetails}
        />
      )}
    </>
  );
};

export default DomainContactType;
